export default __webpack_public_path__ + "static/media/Snd_TryW.453f2106.mp3";